export default {
    readable(value) {
        if (value === '' || value === undefined || value === null) {
            value = '-'
        }
        return value
    },
    trunc(value, length) {
        if (value.length > length) {
            value = value.slice(0, length)
        }
        return value
    },
    format (format) {
        var args = Array.prototype.slice.call(arguments, 1)
        return format.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] !== 'undefined'
                ? args[number]
                : match
        })
    },
    generateHash () {
        return Math.random().toString(36).slice(-10)
    }
}